import React, { Component } from "react";
import { esqueciSenha } from "../../crud/auth.crud";
import { Formik } from 'formik';
import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

class ForgotPassword extends Component {
	constructor() {
		super();

		this.state = {
			loading: false,
			loadingButtonStyle: { paddingRight: "2.5rem" },
		};
	}

	enableLoading = () => {
		this.setState({ loading: true, loadingButtonStyle: { paddingRight: "3.5rem" } });
	};

	disableLoading = () => {
		this.setState({ loading: false, loadingButtonStyle: { paddingRight: "2.5rem" } });
	};

	submit = values => {
		if (!values.email) return Swal.fire('Ops!', 'Insira seu e-mail, antes de continuar.', 'error');

		this.enableLoading();

		esqueciSenha(values).then(() => {
			return Swal.fire('Tudo certo!', 'Foi mandando um email para você, verifique sua caixa de entrada!', 'success');
		}).catch(({ response }) => {
			if (response.data.errors) return Swal.fire('Ops!', response.data.errors[0], 'error');
			else return Swal.fire('Ops!', 'Houve um problema. Entre em contato com o suporte.', 'error');
		}).finally(() => {
			this.disableLoading();
		});
	}

	render = () => {
		return (
			<>
				<div className="kt-login__head"></div>

				<div className="kt-login__body">
					<div className="kt-login__form">
						<div className="kt-login__title">
							<h3>Esqueceu sua senha?</h3>
						</div>

						<Formik initialValues={{ email: "" }} onSubmit={values => this.submit(values)}>
							{({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
								<form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
									<FormControl fullWidth error={Boolean(touched.email && errors.email)} className="mt-3">
										<TextField type="email" variant="outlined" name="email" label="E-mail"
											onBlur={handleBlur} onChange={handleChange} value={values.email}
											error={Boolean(touched.email && errors.email)} />
										{touched.email && errors.email ? <FormHelperText>{errors.email}</FormHelperText> : null}
									</FormControl>

									<div className="kt-login__actions">
										<Link to="/auth/login" className="kt-login__link-forgot">Voltar para o login</Link>

										<button id="kt_login_forgot_submit" type="submit" className={`btn btn-primary btn-elevate kt-login__btn-primary`}
											style={this.state.loadingButtonStyle}>Enviar link</button>
									</div>
								</form>
							)}
						</Formik>
					</div>
				</div>
			</>
		);
	}
}

export default ForgotPassword;
